import { CollaborationResult, ICollaboration } from '@descomplica/microfrontend-core';
import { inject, injectable } from 'tsyringe';

import type { IPegasusGateway, LiveStreamingDto } from '../interfaces/pegasus.gateway';

@injectable()
export class GetLiveStreamingByHighestClassificationLevelCollaboration
  implements ICollaboration<string, CollaborationResult<LiveStreamingDto>>
{
  constructor(
    @inject('IPegasusStudyPlanGateway')
    private readonly pegasusIOGateway: IPegasusGateway,
  ) {}

  public async run(guid: string) {
    return this.pegasusIOGateway.getLiveStreamingByGuid(guid);
  }
}
